import {createFileRoute} from '@tanstack/react-router';
import {ConnectBankCancelPage} from 'features/saved-accounts/pages/ConnectBankCancelPage';

export const Route = createFileRoute(
  '/_protected/home/service/connect-bank/cancel',
)({
  component: ConnectBankCancelPage,
});
